import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import * as UserActions from '../actions/user.actions';
import { UserService } from '../services/user.service';

@Injectable()
export class UserEffects {

    constructor(
        private actions$: Actions,
        private userService: UserService
    ) { }

    dismissBanner$ = createEffect(() =>
        this.actions$.pipe(
            ofType(UserActions.dismissBanner),
            switchMap(({ banner }) =>
                this.userService.dismissBanner(banner).pipe(
                    map((dismissedBanners) =>
                        UserActions.dismissBannerSuccess({ dismissedBanners })
                    ),
                    catchError((error) => of(UserActions.dismissBannerFailure({ error })))
                )
            )
        )
    );

    updateLastSeenReleaseId$ = createEffect(() =>
        this.actions$.pipe(
            ofType(UserActions.updateLastSeenReleaseId),
            mergeMap(({ releaseId }) =>
                this.userService.updateLastSeenReleaseId(releaseId).pipe(
                    map(() =>
                        UserActions.updateLastSeenReleaseIdSuccess({ releaseId })
                    ),
                    catchError((error) =>
                        of(UserActions.updateLastSeenReleaseIdFailure({ error }))
                    )
                )
            )
        )
    );


}
